<div class='SignupCreate__wrapper'>
  <div class='SignupCreate__wrapper__container'>
    <p class='mt-3 mb-0 font-weight-bolder'>
      Please select the type of user you want to register and complete the form
      below.
    </p>
    <div
      [formGroup]='registerForm'
      class='SignupCreate__wrapper__container__form'>
      <mat-radio-group
        aria-label='Select an user type'
        formControlName='user_type'>
        <div class='SignupCreate__wrapper__container__form__row mt-5'>
          <div
            (click)="selectType('user')"
            class='SignupCreate__wrapper__container__form__row__radio'>
            <mat-radio-button class='me-2' value='user'>
              Retreva - Select this option to send emails and start prospecting. This is a fully functioning account
              designed for starting sales conversations.
            </mat-radio-button>
          </div>
          <div
            (click)="selectType('manager')"
            class='SignupCreate__wrapper__container__form__row__radio mt-5'>
            <mat-radio-button class='me-2' value='manager'>
              View Only - Choose this if you're adding multiple Retreva accounts and only need visibility into their
              activity. This account does not send emails and is used for reporting purposes only.
            </mat-radio-button>
          </div>
        </div>
      </mat-radio-group>
      <div class='SignupCreate__wrapper__container__form__row mt-3'>
        <app-text-field
          class='w-100'
          formControlName='email'
          placeholder='Email Address'
          type='email'></app-text-field>
        <div
          *ngIf='hasControlErrors(email) || isEmailTaken'
          class='alert alert-danger'>
          <div *ngIf='email.errors && email.errors.required'>
            <p class='mb-0'>Email address is required.</p>
          </div>
          <div *ngIf='email.errors && email.errors.minlength'>
            <p class='mb-0'>
              Email address must be at least 4 characters long.
            </p>
          </div>
          <div *ngIf='email.errors && email.errors.email'>
            <p class='mb-0'>Please, enter valid email address</p>
          </div>
          <div *ngIf='isEmailTaken'>
            <ng-template *ngIf='!emailErrors.length; else emailErrorsTemplate'>
              <p class='mb-0'>Email address is already taken</p>
            </ng-template>
            <ng-template #emailErrorsTemplate>
              <p *ngFor='let error of emailErrors' class='mb-0'>{{ error }}</p>
            </ng-template>
          </div>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 col-md-6'>
          <app-text-field
            formControlName='first_name'
            placeholder='First name'></app-text-field>
          <div *ngIf='hasControlErrors(first_name)' class='alert alert-danger'>
            <div *ngIf='first_name.errors.required'>
              <p class='mb-0'>First Name is required.</p>
            </div>
          </div>
        </div>
        <div class='col col-12 col-md-6 mt-3 mt-sm-0'>
          <app-text-field
            formControlName='last_name'
            placeholder='Last name'></app-text-field>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12'>
          <app-text-field
            class='w-100'
            formControlName='company'
            placeholder='Company'></app-text-field>
          <div *ngIf='hasControlErrors(company)' class='alert alert-danger'>
            <div *ngIf='company.errors.required'>
              <p class='mb-0'>Company is required.</p>
            </div>
          </div>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12'>
          <app-text-field
            class='w-100'
            formControlName='phone_number'
            placeholder='Phone number: e.g. (555) 123-4567'
            type='tel'></app-text-field>
          <div *ngIf='(phone_number.dirty || phone_number.touched) && phone_number.errors?.pattern'
               class='alert alert-danger'>
            <p class='mb-0'>Invalid phone number format. e.g. (555) 123-4567 for US or +12505550199 for Canada</p>
          </div>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 col-md-6'>
          <app-text-field
            formControlName='address1'
            placeholder='Address 1'></app-text-field>
        </div>
        <div class='col col-12 col-md-6 mt-3 mt-sm-0'>
          <app-text-field
            formControlName='address2'
            placeholder='Address 2'></app-text-field>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 col-md-6'>
          <app-select
            (selection)='onCountrySelect($event)'
            [items]='getCountryItems()'
            formControlName='country'
            label='Select country'></app-select>
          <div
            *ngIf='(country.dirty || country.touched) && country.errors'
            class='alert alert-danger'>
            <div *ngIf='country.errors.required'>
              <p class='mb-0'>Please, select country.</p>
            </div>
          </div>
        </div>
        <div class='col col-12 col-md-6 mt-3 mt-sm-0'>
          <app-text-field
            formControlName='city'
            placeholder='City'></app-text-field>
          <div *ngIf='hasControlErrors(city)' class='alert alert-danger'>
            <div *ngIf='city.errors.required'>
              <p class='mb-0'>City is required.</p>
            </div>
          </div>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 col-md-6'>
          <app-select
            *ngIf="!selectedCountry || selectedCountry === 'US'"
            [items]="getStates('US')"
            formControlName='state'
            label='State'></app-select>
          <app-select
            *ngIf="selectedCountry && selectedCountry === 'CA'"
            [items]="getStates('CA')"
            formControlName='state'
            label='State'></app-select>
          <div
            *ngIf='(state.dirty || state.touched) && state.errors'
            class='alert alert-danger'>
            <div *ngIf='state.errors.required'>
              <p class='mb-0'>Please, select a state.</p>
            </div>
          </div>
        </div>
        <div class='col col-12 col-md-6 mt-3 mt-sm-0'>
          <app-text-field
            formControlName='zip'
            placeholder='Zip Code...'></app-text-field>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12'>
          <app-select
            *ngIf="!selectedCountry || selectedCountry === 'US'"
            [items]="getTimezones('US')"
            formControlName='time_zone'
            label='Selected Time Zone'></app-select>
          <app-select
            *ngIf="selectedCountry && selectedCountry === 'CA'"
            [items]="getTimezones('CA')"
            formControlName='time_zone'
            label='Selected Time Zone'></app-select>
          <div
            *ngIf='(time_zone.dirty || time_zone.touched) && time_zone.errors'
            class='alert alert-danger'>
            <div *ngIf='time_zone.errors.required'>
              <p class='mb-0'>Please, select a timezone.</p>
            </div>
          </div>
          <p class='mt-2'>
            Please be sure to click Observe DST for Eastern Time and other zones
            if applicable.
          </p>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12'>
          <mat-checkbox formControlName='user_dst_bit'
          >Select to Observe DST
          </mat-checkbox
          >
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12'>
          <app-text-field
            [allowViewPassword]='true'
            formControlName='password'
            placeholder='Password'
            type='password'></app-text-field>
          <div *ngIf='hasControlErrors(password)' class='alert alert-danger'>
            <div *ngIf='password.errors.required'>
              <p class='mb-0'>Password is required.</p>
            </div>
            <div *ngIf='password.errors.minlength'>
              <p class='mb-0'>Password must be at least 8 characters long.</p>
            </div>
            <div *ngIf='password.errors'>
              <ul>
                <li *ngIf='password.errors.numberValue'>Numbers: 0 to 9</li>
                <li *ngIf='password.errors.uppercaseValue'>Uppercase Letters: ABC</li>
                <li *ngIf='password.errors.lowercaseValue'>Lowercase Letters: abc</li>
                <li *ngIf='password.errors.specialCharValue'>Special Characters: ! @ # $ % & * ( ) _ + - = &#123;} [ ] ;
                  : ' " < > , . ? /
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12'>
          <app-text-field
            [allowViewPassword]='true'
            formControlName='confirm_password'
            placeholder='Confirm Password...'
            type='password'></app-text-field>
          <div
            *ngIf='hasControlErrors(confirm_password)'
            class='alert alert-danger'>
            <div *ngIf='confirm_password.errors.required'>
              <p class='mb-0'>Please, repeat your password</p>
            </div>
            <div *ngIf='confirm_password.errors.minlength'>
              <p class='mb-0'>Password must be at least 8 characters long.</p>
            </div>
            <div *ngIf='confirm_password.errors.not_same_as'>
              <p class='mb-0'>Password didn't match as above</p>
            </div>
          </div>
        </div>
      </div>

      <div class='row mt-3'>
        <div
          class='col flex-grow-1 w-lg-50 m-auto text-center RegisterStepCreate_wrapper_footer'>
          <p class='p-0 mb-0'>
            <mat-checkbox formControlName='terms_accepted'>I agree to the <a href='/terms' target='_blank'>End User
              Terms of Service</a></mat-checkbox>
          </p>
          <div
            *ngIf="((registerForm.get('terms_accepted').touched || registerForm.get('terms_accepted').dirty) && registerForm.get('terms_accepted').errors?.required) || ((registerForm.get('terms_accepted').touched || registerForm.get('terms_accepted').dirty) && !registerForm.get('terms_accepted').value)"
            class='alert alert-danger'>
            <p class='p-0 mb-0'>
              Please, accept the End User Terms of Service
            </p>
          </div>
          <p>
            (I may receive communications from Retreva® and can change my
            notification preferences in
            <a href='/login'>My Account</a> )
          </p>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 text-center'>
          <app-button
            #buttonComponent
            (click)='submitForm()'
            [observeApi]='true'
            [style]="'rounded'"
            color='orange'
            size='normal'
            text='Next'></app-button>
        </div>
      </div>
    </div>
  </div>
</div>
